import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../../query"
import api, { createUrlParams } from "../../client"
import { GetOrderTemplatesRequestQuery, OrderTemplatesResponseData } from "../../types/order-template"

const getData = async (query: GetOrderTemplatesRequestQuery) => {
  const { data } = await api.get(`/order-templates${createUrlParams(query)}`)
  return data
}

export const useOrderTemplates = (query: GetOrderTemplatesRequestQuery)
  : QueryObserverBaseResult<OrderTemplatesResponseData> => {
  const { data, ...props } = useQuery<OrderTemplatesResponseData>(
    queryKeys.ORDER_TEMPLATES(query),
    () => getData(query),
  )
  return { data, ...props }
}
